import { GridCellParams, GridColDef } from "@mui/x-data-grid";

export const formatData = (data) => {
  return data.map((o, i) => {
    o.id = i + 1;
    return o;
  });
};

export const columns: GridColDef[] = [
  {
    cellClassName: (params) => getCellClassName(params) + " MuiDataGrid-cell--textCenter",
    field: "instructor_name",
    flex: 0.2,
    headerAlign: "center",
    headerName: "Instructor Name",
    type: "string",
  },
  {
    cellClassName: (params) => getCellClassName(params) + " MuiDataGrid-cell--textCenter",
    field: "no_of_members",
    flex: 0.1,
    headerAlign: "center",
    headerName: "Number of Members",
    type: "number",
  },
  {
    cellClassName: (params) => getCellClassName(params),
    field: "completed_appt_1",
    flex: 0.15,
    headerName: "Completed Followup Appt. 1",
    type: "number",
  },
  {
    cellClassName: (params) => getCellClassName(params),
    field: "completed_appt_2",
    flex: 0.15,
    headerName: "Completed Followup Appt. 2",
    type: "number",
  },
  {
    cellClassName: (params) => getCellClassName(params),
    field: "completed_appt_3",
    flex: 0.15,
    headerName: "Completed Followup Appt. 3",
    type: "number",
  },
  {
    cellClassName: (params) => getCellClassName(params),
    field: "completed_appt_4",
    flex: 0.15,
    headerName: "Completed Followup Appt. 4",
    type: "number",
  },
  {
    cellClassName: (params) => getCellClassName(params),
    field: "completed_appt_5",
    flex: 0.15,
    headerName: "Completed Followup Appt. 5",
    type: "number",
  },
  {
    cellClassName: (params) => getCellClassName(params),
    field: "percent_graduated",
    flex: 0.15,
    headerAlign: "right",
    headerName: "Percent Graduated",
    type: "number",
  },
];

export const columnsForPdf: GridColDef[] = [
  {
    cellClassName: (params) => getCellClassName(params) + " MuiDataGrid-cell--textCenter",
    field: "instructor_name",
    headerAlign: "center",
    headerName: "Instructor Name",
    type: "string",
    width: 105,
  },
  {
    cellClassName: (params) => getCellClassName(params) + " MuiDataGrid-cell--textCenter",
    field: "no_of_members",
    headerAlign: "center",
    headerName: "# of Members",
    type: "number",
    width: 93,
  },
  {
    cellClassName: (params) => getCellClassName(params),
    field: "completed_appt_1",
    headerName: "Completed #1",
    type: "number",
    width: 93,
  },
  {
    cellClassName: (params) => getCellClassName(params),
    field: "completed_appt_2",
    headerName: "Completed #2",
    type: "number",
    width: 93,
  },
  {
    cellClassName: (params) => getCellClassName(params),
    field: "completed_appt_3",
    headerName: "Completed #3",
    type: "number",
    width: 93,
  },
  {
    cellClassName: (params) => getCellClassName(params),
    field: "completed_appt_4",
    headerName: "Completed #4",
    type: "number",
    width: 93,
  },
  {
    cellClassName: (params) => getCellClassName(params),
    field: "completed_appt_5",
    headerName: "Completed #5",
    type: "number",
    width: 93,
  },
  {
    cellClassName: (params) => getCellClassName(params),
    field: "percent_graduated",
    headerAlign: "right",
    headerName: "% Graduated",
    type: "number",
    width: 95,
  },
];

const PRINT_WIDTH = 1150 / 8;

export const columnsForPrint: GridColDef[] = [
  {
    cellClassName: (params) => getCellClassName(params) + " MuiDataGrid-cell--textCenter",
    field: "instructor_name",
    headerAlign: "center",
    headerName: "Instructor Name",
    type: "string",
    width: PRINT_WIDTH,
  },
  {
    cellClassName: (params) => getCellClassName(params) + " MuiDataGrid-cell--textCenter",
    field: "no_of_members",
    headerAlign: "center",
    headerName: "# of Members",
    type: "number",
    width: PRINT_WIDTH,
  },
  {
    cellClassName: (params) => getCellClassName(params),
    field: "completed_appt_1",
    headerName: "Completed #1",
    type: "number",
    width: PRINT_WIDTH,
  },
  {
    cellClassName: (params) => getCellClassName(params),
    field: "completed_appt_2",
    headerName: "Completed #2",
    type: "number",
    width: PRINT_WIDTH,
  },
  {
    cellClassName: (params) => getCellClassName(params),
    field: "completed_appt_3",
    headerName: "Completed #3",
    type: "number",
    width: PRINT_WIDTH,
  },
  {
    cellClassName: (params) => getCellClassName(params),
    field: "completed_appt_4",
    headerName: "Completed #4",
    type: "number",
    width: PRINT_WIDTH,
  },
  {
    cellClassName: (params) => getCellClassName(params),
    field: "completed_appt_5",
    headerName: "Completed #5",
    type: "number",
    width: PRINT_WIDTH,
  },
  {
    cellClassName: (params) => getCellClassName(params),
    field: "percent_graduated",
    headerAlign: "right",
    headerName: "% Graduated",
    type: "number",
    width: PRINT_WIDTH,
  },
];

/** Function to update Style for row */
const getCellClassName = (params: GridCellParams<any, any, any>) => {
  let cellClass = "";
  const isOddCell = (parseInt(params.id.toString()) + 1) % 2 !== 0;
  if (isOddCell) {
    cellClass += "odd-row";
  }

  if (params.colDef.headerName === "Date Reached") {
    cellClass += " last-cell";
  }

  return cellClass;
};

export const generateCsvData = (data) => {
  const headerData = [
    [
      columns[0].headerName,
      columns[1].headerName,
      columns[2].headerName,
      columns[3].headerName,
      columns[4].headerName,
      columns[5].headerName,
      columns[6].headerName,
      columns[7].headerName,
    ],
  ];
  const rowData = data.map((x) => [
    x[columns[0].field],
    x[columns[1].field],
    x[columns[2].field],
    x[columns[3].field],
    x[columns[4].field],
    x[columns[5].field],
    x[columns[6].field],
    x[columns[7].field],
  ]);

  return headerData.concat(rowData);
};
